/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: 001-promotor-sales-activity
*/

import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { isWeb } from '@global/screens';
import { ARROW_SIZE } from '@/constants';
import Colors from '@global/colors';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import TitleSubSection from '@components/global/TitleSubSection';
import ItemDetail from '@components/global/ItemDetail';
import CustomerDisplay from '@/screens/sales-activity/components/todo-list/customer-display/CustomerDisplay';
import CompetitorUpdateSection from '@/screens/sales-activity/components/todo-list/competitor-update/CompetitorUpdate';
import GwpTrackerDisplay from '@/screens/sales-activity/components/todo-list/gwp-tracker/GwpTrackerDisplay';
import VisitReport from '@/screens/sales-activity/components/todo-list/visit-report/VisitReport';
import SellOutReportDisplay from '@/screens/sales-activity/components/todo-list/sell-out-report/SellOutReportDisplay';
import VisibilityUpdateProductCard from '@/screens/sales-activity/components/todo-list/visibility-update/VisibilityUpdateProductCard';
import ModalImage from '@components/modal/ModalImage';

const TodoListEvent = ({ detailData = {}, detailTodos = [] }) => {
  const userRole = detailData?.user?.role || '';
  const [activeTab, setActiveTab] = useState(
    isWeb ? ['category_activity'] : [],
  );
  const [activeVisibilityTab, setActiveVisibilityTab] = useState('product');
  const [visibilityVisibleCount, setVisibilityVisibleCount] = useState(12);

  const isActive = (value) => activeTab.indexOf(value) > -1;

  const toggleTab = (value) => {
    if (isWeb) {
      const temp = [...activeTab];
      const index = temp.indexOf(value);
      if (index > -1) {
        temp.splice(index, 1);
      } else {
        temp.push(value);
      }
      setActiveTab(temp);
    } else {
      setActiveTab(isActive(value) ? [] : [value]);
    }
  };

  const TabExpand = ({ title, value }) => (
    <TouchableOpacity
      testID={`todo-event-tab-expand-${value}`}
      onPress={() => toggleTab(value)}
      activeOpacity={0.6}
      style={{
        width: '100%',
        paddingHorizontal: 15,
        paddingVertical: 17,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: isWeb ? Colors.grey3 : Colors.white,
        ...(!isWeb
          ? { borderBottomColor: Colors.grey0, borderBottomWidth: 1 }
          : {}),
      }}>
      <SociollaText
        type="medium"
        style={{ color: Colors.grey1, textTransform: 'uppercase' }}>
        {title}
      </SociollaText>
      <Image
        style={[
          ARROW_SIZE,
          {
            marginRight: isWeb ? 5 : -10,
            transform: [
              {
                rotate: !isWeb ? '-90deg' : isActive(value) ? '180deg' : '0deg',
              },
            ],
          },
        ]}
        width={ARROW_SIZE.width}
        height={ARROW_SIZE.height}
        svg={true}
        source={require('@assets/img/icons/arrow-down-grey.svg')}
      />
    </TouchableOpacity>
  );

  // Category Activity
  const categoryActivity = detailData?.category_activity;
  // B2B-5929: online platforms only share value sell out
  const isValueSellOutOnly =
    userRole === 'promotor' && categoryActivity === 'ONLINE';
  const eventActivityType =
    detailData?.event_activity_other || detailData?.event_activity_type;

  // Customer Display
  const dataCustomerDisplay = detailTodos.find(
    (a) => a.target_type == 'customer_display',
  );
  let beforeImage = [];
  let afterImage = [];
  if (dataCustomerDisplay) {
    const detailCustomerDisplay = dataCustomerDisplay.more_info || {};
    const before = detailCustomerDisplay.attachments?.length
      ? detailCustomerDisplay.attachments.find(
          (a) => a.type == 'customer_before_visit',
        )
      : null;
    beforeImage = before?.image?.length ? before.image.map((a) => a.url) : [];
    const after = detailCustomerDisplay.attachments?.length
      ? detailCustomerDisplay.attachments.find(
          (a) => a.type == 'customer_after_visit',
        )
      : null;
    afterImage = after?.image?.length
      ? after.image.map((a) => ({ url: a.url, text: a.text || '' }))
      : [];
  }
  const dataCustomerDisplayExtras =
    dataCustomerDisplay?.more_info?.attachments || [];
  const endGondolaImage = (
    dataCustomerDisplayExtras.find((a) => a.type == 'customer_end_gondola')
      ?.image || []
  ).map((a) => a.url);
  const standeeImage = (
    dataCustomerDisplayExtras.find((a) => a.type == 'customer_standee')
      ?.image || []
  ).map((a) => a.url);
  const cocImage = (
    dataCustomerDisplayExtras.find((a) => a.type == 'customer_coc')?.image || []
  ).map((a) => a.url);

  // Competitor Update
  const dataCompetitorUpdate = detailTodos.find(
    (a) => a.target_type == 'competitor_update',
  );
  const competitorAttachment =
    dataCompetitorUpdate?.more_info?.attachments?.find(
      (a) => a.type == 'competitor',
    );
  const competitorImages = competitorAttachment?.image?.length
    ? competitorAttachment.image.map((a) => ({
        url: a.url,
        text: a.text || '',
      }))
    : [];

  // Visibility Update
  const dataVisibilityUpdate = detailTodos.find(
    (a) => a.target_type == 'visibility_update',
  );
  const visibilityProducts = dataVisibilityUpdate?.products || [];
  const otherProducts = dataVisibilityUpdate?.other_products || [];
  const vuCurrentList =
    activeVisibilityTab === 'other_product'
      ? otherProducts
      : visibilityProducts;
  const vuVisibleList = vuCurrentList.slice(0, visibilityVisibleCount);

  // GWP Tracker
  const dataGwpTracker = detailTodos.find(
    (a) => a.target_type == 'gwp_tracker',
  );
  const gwpTrackers = dataGwpTracker?.more_info?.campaign?.length
    ? dataGwpTracker.more_info.campaign
    : [];

  // Visit Report (npd_presentation)
  const dataNpdPresentation = detailTodos.find(
    (a) => a.target_type == 'npd_presentation',
  );
  let visitNotes = [];
  let visitPlanNpd = [];
  if (dataNpdPresentation) {
    const detailNotes = dataNpdPresentation.more_info || {};
    visitNotes = detailNotes.notes?.length
      ? detailNotes.notes.filter((a) => a.type == 'npd_presentation')
      : [];
    visitPlanNpd = detailNotes.plan_for_next_visit?.length
      ? detailNotes.plan_for_next_visit.filter(
          (a) => a.type == 'npd_presentation',
        )
      : [];
  }

  // Sell-out Validation Report
  const dataSellOutReport = detailTodos.find(
    (a) => a.target_type == 'sell_out_report',
  );
  const sellOutReports = dataSellOutReport?.more_info?.report?.length
    ? dataSellOutReport.more_info.report
    : [];

  const renderEmpty = () => (
    <View style={{ padding: 15 }}>
      <SociollaText style={{ color: Colors.grey1, fontSize: 13 }}>
        No data yet.
      </SociollaText>
    </View>
  );

  return (
    <View testID="todo-event-container" style={{ width: '100%' }}>
      {/* Category Activity */}
      <TitleSubSection title="CATEGORY ACTIVITY" />
      <View style={{ padding: 15 }}>
        <ItemDetail name="Category" value={categoryActivity || '-'} />
        <ItemDetail
          name="Event Activity Type"
          value={eventActivityType || '-'}
        />
      </View>

      {/* Customer Display */}
      <TabExpand title="Customer Display" value="customer_display" />
      {isActive('customer_display') && (
        <CustomerDisplay
          beforeImage={beforeImage}
          afterImage={afterImage}
          endGondolaImage={endGondolaImage}
          standeeImage={standeeImage}
          cocImage={cocImage}
          userRole={userRole}
        />
      )}

      {/* Competitor Update */}
      <TabExpand title="Competitor Update" value="competitor_update" />
      {isActive('competitor_update') && (
        <CompetitorUpdateSection images={competitorImages} />
      )}

      {/* Visibility Update */}
      <TabExpand title="Visibility Update" value="visibility_update" />
      {isActive('visibility_update') && (
        <View style={{ backgroundColor: Colors.grey3, paddingTop: 8 }}>
          {/* Product / Other Product tabs */}
          <View
            style={{
              marginHorizontal: isWeb ? 0 : 12,
              marginBottom: 8,
              padding: 4,
              borderRadius: 10,
              backgroundColor: Colors.white,
              flexDirection: 'row',
              borderColor: Colors.grey0,
              borderWidth: 1,
            }}>
            {[
              {
                key: 'product',
                label: 'Product',
                count: visibilityProducts.length,
              },
              {
                key: 'other_product',
                label: 'Other Product',
                count: otherProducts.length,
              },
            ].map((tab) => {
              const isActiveTab = activeVisibilityTab === tab.key;
              return (
                <TouchableOpacity
                  testID={`todo-event-vu-tab-${tab.key}`}
                  key={tab.key}
                  activeOpacity={0.8}
                  style={[
                    {
                      flex: 1,
                      borderRadius: 8,
                      paddingVertical: isWeb ? 8 : 10,
                      paddingHorizontal: 8,
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'row',
                    },
                    isActiveTab && { backgroundColor: Colors.blue9 },
                  ]}
                  onPress={() => {
                    setActiveVisibilityTab(tab.key);
                    setVisibilityVisibleCount(12);
                  }}>
                  <SociollaText
                    type={isActiveTab ? 'medium' : 'regular'}
                    style={[
                      { fontSize: isWeb ? 14 : 12, color: Colors.grey2 },
                      isActiveTab && { color: Colors.blue0 },
                    ]}>
                    {tab.label}
                  </SociollaText>
                  <View
                    style={[
                      {
                        borderRadius: 11,
                        marginLeft: 6,
                        paddingVertical: 2,
                        paddingHorizontal: 12,
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: Colors.grey3,
                      },
                      isActiveTab && { backgroundColor: Colors.blue0 },
                    ]}>
                    <SociollaText
                      type="medium"
                      style={[
                        { fontSize: 12 },
                        isActiveTab && { color: Colors.white },
                      ]}>
                      {tab.count}
                    </SociollaText>
                  </View>
                </TouchableOpacity>
              );
            })}
          </View>

          {/* Product cards */}
          {vuVisibleList.length
            ? vuVisibleList.map((product, idx) => (
                <VisibilityUpdateProductCard
                  key={`${activeVisibilityTab}-${idx}`}
                  item={product}
                  userRole={userRole}
                  isValueSellOutOnly={isValueSellOutOnly}
                />
              ))
            : renderEmpty()}

          {/* Load More */}
          {vuCurrentList.length > visibilityVisibleCount ? (
            <TouchableOpacity
              testID="todo-event-vu-load-more-btn"
              style={{
                width: '100%',
                paddingVertical: 14,
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: Colors.white,
                borderTopColor: Colors.grey0,
                borderTopWidth: 1,
                borderBottomColor: Colors.grey0,
                borderBottomWidth: 1,
              }}
              activeOpacity={0.6}
              onPress={() => setVisibilityVisibleCount((prev) => prev + 12)}>
              <SociollaText style={{ color: Colors.blue0, fontSize: 12 }}>
                Load More
              </SociollaText>
            </TouchableOpacity>
          ) : null}
        </View>
      )}

      {/* GWP Tracker */}
      <TabExpand title="GWP Tracker" value="gwp_tracker" />
      {isActive('gwp_tracker') && (
        <GwpTrackerDisplay gwpTrackers={gwpTrackers} />
      )}

      {/* Visit Report */}
      <TabExpand title="Visit Report" value="npd_presentation" />
      {isActive('npd_presentation') && (
        <VisitReport notes={visitNotes} plan_npd={visitPlanNpd} />
      )}

      {/* Sell-out Validation Report */}
      {dataSellOutReport ? (
        <React.Fragment>
          <TabExpand
            title="Sell-Out Validation Report"
            value="sell_out_report"
          />
          {isActive('sell_out_report') && (
            <SellOutReportDisplay reports={sellOutReports} />
          )}
        </React.Fragment>
      ) : null}
      <ModalImage />
    </View>
  );
};

export default React.memo(TodoListEvent, (prev, next) => prev == next);
